import { renderComponent } from '../../storyblok/renderComponent';
import { QuestionLayout } from '../../components/QuestionLayout/QuestionLayout';
import { stringOrUndefined } from '../../storyblok/utils/stringOrUndefined';

import type { FC } from 'react';
import type { QuestionLayoutSchema, StepSchema } from '../../storyblok/schemas';
import type { z } from 'zod';
import type { Richtext } from 'storyblok-js-client';

type StepProps = z.infer<typeof StepSchema>;
type QuestionLayoutProps = z.infer<typeof QuestionLayoutSchema>;

export const FormQuestionStep: FC<StepProps> = (props) => {
  const questionLayoutProps = props.children[0] as QuestionLayoutProps;

  return (
    <QuestionLayout
      key={questionLayoutProps._uid}
      back={questionLayoutProps.back}
      submit={questionLayoutProps.submit}
      skip={questionLayoutProps.skip}
      title={questionLayoutProps.title}
      description={questionLayoutProps.description}
      backButtonText={stringOrUndefined(questionLayoutProps.backButtonText)}
      closeButtonText={stringOrUndefined(questionLayoutProps.closeButtonText)}
      submitButtonText={stringOrUndefined(questionLayoutProps.submitButtonText)}
      skipButtonText={stringOrUndefined(questionLayoutProps.skipButtonText)}
      socialProofMessage={props.socialProofMessage as Richtext}
      headerType={props.headerType}
      maxW={!questionLayoutProps.maxW ? undefined : questionLayoutProps.maxW}
      mode={questionLayoutProps.mode || undefined}
      showProgressBar={props.showProgressBar || undefined}
    >
      {questionLayoutProps.children?.map(renderComponent)}
    </QuestionLayout>
  );
};
